<template>
  <div class="schedule container">
    <div class="row">
      <div class="col">
        <PageHeading heading="Results"/>
        <br/>
        <div class="row">
          
          <div class="btn-group col-md-6" role="group" aria-label="Select a division">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio1" value="novice" autocomplete="off" v-model="division" checked>
            <label class="btn btn-outline-dark" for="btnradio1">Novice</label>

            <input type="radio" class="btn-check" name="btnradio" id="btnradio2" value="intermediate" v-model="division" autocomplete="off">
            <label class="btn btn-outline-dark" for="btnradio2">Intermediate</label>

            <input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" v-model="division" value="expert">
            <label class="btn btn-outline-dark" for="btnradio3">Expert</label>
          </div>
          
          <div class="col-md-4">
            <select id="date" class="form-select" v-model="date">
              <option disabled value="">Select a date</option>
              <option v-for="date in dates" :key="date.id" :value="date.date">{{fmtDate(date.date)}} at {{date.location}}</option>
            </select>
          </div>
        </div>
        <h5 v-if="results.length == 0">No Results</h5>
        <table class="table table-striped" id="sched" v-if="results.length > 0">
          <thead>
            <tr>
              <th @click="orderSort('placed')">Place <span>&#x21C5;</span></th>
              <th @click="orderSort('name')">Name <span>&#x21C5;</span></th>
              <th @click="orderSort('team_name')">Team <span>&#x21C5;</span></th>
              <th @click="orderSort('average')">Average Points <span>&#x21C5;</span></th>
              <th @click="orderSort('errors')">Total Errors <span>&#x21C5;</span></th>
              <th @click="orderSort('rounds')">Rounds <span>&#x21C5;</span></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="result in results" :key="result.id">
              <td>{{ result.PLACED }}</td>
              <td>{{ result.NAME }}</td>
              <td>{{ result.TEAM_NAME}}</td>
              <td>{{ result.AVERAGE }}</td>
              <td>{{ result.ERRORS }}</td>
              <td>{{ result.ROUNDS }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeading from '@/components/PageHeading.vue';
import axios from "axios"

export default {
  name: 'Results',
  components: {
    PageHeading
  },
  created() {
    this.date = this.$route.params.date;
    this.loadSchedule();
    this.loadResults();
  },
  data: function() {
    return {
      results: [],
      dates: [],
      date: '',
      division: 'novice',
      sort: 'ASC',
      order: 'placed'
    }
  },
  methods: {
    orderSort(col) { 
      console.log("col clicked: " + col);
      console.log("current order: " + this.order);
      if (this.order == col) {
        this.sort = this.sortDirection;
      } else {
        this.order = col;
        this.sort = 'ASC';
      }
    },
    loadResults: function() {
      console.log("loading results");
      axios.get(process.env.VUE_APP_API_ROOT + "/lib/results.php" + this.params)
      .then((response) => {
        if(response.data !== null) {
          this.results = response.data;
          this.addHashToLocation(this.date);
        } else {
          this.results = [];
          this.addHashToLocation(this.date);
        }
      })
    },
    loadSchedule: function() {
      axios.get(process.env.VUE_APP_API_ROOT + "/lib/schedule.php")
      .then((response) => {
        if(response.data !== null) {
          this.dates = response.data.map (a => {return {date: a.date, location: a.location}});
        }
        if(this.date == undefined) {
          this.date = this.dates[0].date;
        }
      });
    },
    addHashToLocation(params) {
      console.log(this.$route.path);
    history.pushState(
        {},
        null,
        process.env.VUE_APP_API_ROOT + '/results/' + encodeURIComponent(params)
      )
    }
  },
  computed: {
    sortDirection: function() {
      return this.sort == 'ASC' ? 'DESC' : 'ASC';
    },
    params: function() {
      let p = '';
      if (this.date) {

        p = p + "?date=" + this.date;
      }
      if (this.division) {
        p = p ? p + "&" : p + "?";
        p = p + "div=" + this.division;
      }
      if(this.sort) {
        p = p ? p + "&" : p + "?";
        p = p + "sort=" + this.sort;
      }
      if(this.order) {
        p = p ? p + "&" : p + "?";
        p = p + "order=" + this.order;
      }
      return p;
    }
  },
  watch: {
    division: 'loadResults',
    date: 'loadResults',
    sort: 'loadResults',
    order: 'loadResults'
  }
}
</script>

<style scoped>
  .table, h5 {
    margin-top: 2em;
  }
  th {
        cursor: pointer;  
  }
  th > span {
    color: #C8C8C8;
    font-size: 1.4em;
    display: inline-block;
    position: relative;
    bottom: -0.05em;
  }
  .btn-group {
    margin-bottom: 1em;
  }
  .btn-outline-dark {
    outline: none !important;
    box-shadow: none !important;
    color: #444;
    border-color: #444;
  }
  .btn-check:active+.btn-outline-dark, .btn-check:checked+.btn-outline-dark, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show, .btn-outline-dark:active {
    color: #fff;
    background-color: #444;
    border-color: #444;
  }
  .btn-outline-dark:hover {
    background: #444;
    color: #fff;
  }
  #date {
    outline: 1px solid black;
  }
</style>